import '../styles/app.css'
import { StrictMode, createElement } from 'react'
import { createRoot } from 'react-dom/client'
import App from '../App'

createRoot(document.getElementById('root')!).render(
  createElement(StrictMode, null, createElement(App))
)
